// Write your code here.
import {Component} from 'react'
import './index.css'

class LettersCalculator extends Component {
  state = {count: 0, inputSearch: ''}

  inputfunction = event => {
    const a = event.target.value
    this.setState(prevState => ({count: prevState.count + 1, inputSearch: a}))
  }

  render() {
    const {inputSearch, count} = this.state
    return (
      <div className="main_container">
        <div className="div_1">
          <h1>Calculate the Letters you enter</h1>
          <label htmlFor="input">Enter the phrase</label>
          <input
            className="input"
            type="text"
            id="input"
            placeholder="Enter the phrase"
            value={inputSearch}
            onChange={this.inputfunction}
          />

          <div className="count_container">
            <p>No.of Letters: {count}</p>
          </div>
        </div>
        <div className="image_container">
          <img
            className="image"
            alt="letters calculator"
            src="https://assets.ccbp.in/frontend/react-js/stop-watch-with-calculator-img.png"
          />
        </div>
      </div>
    )
  }
}
export default LettersCalculator
